<dynamic-form
  [apiName]="apiName"
  [label]="label"
  [group]="DateValueFormGroup"
  [areaName]="areaName"
  [model]="model"
  [columns]="columns"
  (cancelChange)="cancel()"
  (submitChange)="submitValue()"
  [isSaved]="isSaved"
  [saveLabel]="'ClientApp.FrontOffice.DateDialog.Confirm' | translate">
  <ng-container class="content">
    <div class="date-excel-export-dialog">
      <date-picker
        name="StartDate"
        [group]="DateValueFormGroup"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.StartDate' | translate"
        textType="date"
        [disabled]="false"></date-picker>
      <date-picker
        name="EndDate"
        [group]="DateValueFormGroup"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.EndDate' | translate"
        textType="date"
        [disabled]="false"></date-picker>
      <ssg-button [label]="'ClientApp.FrontOffice.DateDialog.Preview' | translate" class="show" *ngIf="hasAcc"></ssg-button>

      <div class="boxes">
        <ssg-select
          *ngIf="statusList"
          name="StatusCode"
          [dataList]="statusDataList"
          textFieldName="Title"
          valueFieldName="Id"
          userClass="select-sm"
          [group]="DateValueFormGroup"
          [label]="'ClientApp.FrontOffice.DateDialog.StatusOfSentInvoices' | translate">
        </ssg-select>
      </div>
    </div>
    <div>
      <ssg-checkbox
        *ngIf="hasDeposit"
        id="HasInvoiceService"
        name="HasInvoiceService"
        [group]="DateValueFormGroup"
        [label]="'ClientApp.FrontOffice.DateDialog.InvoicesWithoutServiceRelatedPersons' | translate">
      </ssg-checkbox>
    </div>
    <div>
      <ssg-checkbox
        *ngIf="hasResponse"
        id="HasGetResponse"
        name="HasGetResponse"
        [group]="DateValueFormGroup"
        [label]="'ClientApp.FrontOffice.DateDialog.InquiryOfSentInvoices' | translate">
      </ssg-checkbox>
    </div>
    <div>
      <ssg-checkbox
        *ngIf="hasResendFactors"
        id="ResendFactors"
        name="ResendFactors"
        [group]="DateValueFormGroup"
        [label]="'ClientApp.FrontOffice.DateDialog.resend' | translate">
      </ssg-checkbox>
    </div>
    <ssg-tabset class="tab-container" *ngIf="hasAcc">
      <ssg-tab [tabTitle]="'ClientApp.FrontOffice.DateDialog.AccountingDocument' | translate">
        <kgrid
          [noAutoFitColumns]="true"
          [hideToolber]="true"
          [areaName]="areaName"
          [label]="label"
          [name]="apiName"
          [dataList]="DetailLedgerList"
          [isMulti]="true"
          [isEdit]="false"
          [isDelete]="false"
          pagingSize="5"
          pathPreFix="SALE"
          [columns]="gridColumns">
        </kgrid>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
